/* eslint-disable no-case-declarations */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unreachable */
import { cloneDeep, findIndex, map } from 'lodash';
import moment from 'moment';
import { clubs } from '../../constants';
import {
    CLUBS_FETCH_HIGHSCHOOL_STANDINGS,
    CLUBS_FETCH_HIGHSCHOOL_STANDINGS_FAILURE,
    CLUBS_FETCH_HIGHSCHOOL_STANDINGS_SEASONS,
    CLUBS_FETCH_HIGHSCHOOL_STANDINGS_SEASONS_FAILURE,
    CLUBS_FETCH_HIGHSCHOOL_STANDINGS_SEASONS_SUCCESS,
    CLUBS_FETCH_HIGHSCHOOL_STANDINGS_SUCCESS,
} from '../actions/actionTypes/club-action-types';
import {
    EVENTS_DELETE_SUCCESS,
    EVENTS_INCLUDE_IN_CONFERENCE_SUCCESS,
    EVENTS_OMIT_FROM_CONFERENCE_SUCCESS,
    EVENTS_PUBLISH_SUCCESS,
    EVENTS_SAVE_SUCCESS,
    EVENTS_UNPUBLISH_SUCCESS,
    EVENTS_UPDATE_SUCCESS,
} from '../actions/actionTypes/event-action-types';
import {
    CLUBS_CHANGE_MEMBERSHIP_TYPE,
    CLUBS_CHANGE_MEMBERSHIP_TYPE_FAILURE,
    CLUBS_GET_ORGANIZERS_SUCCESS,
    CLUBS_REMOVE_MEMBERS,
    CLUBS_REMOVE_MEMBERS_FAILURE,
    CLUBS_SEARCH_MEMBERS,
    CLUBS_SEARCH_MEMBERS_FAILURE,
    CLUBS_SEARCH_MEMBERS_SUCCESS,
    CLUBS_UPDATE_FETCHSTATE,
    CLUBS_UPDATE_MEMBER_SELECTION,
    CLUB_GET_SCHOOL_DETAILS,
    CLUB_GET_SCHOOL_DETAILS_FAILURE,
    CLUB_GET_SCHOOL_DETAILS_SUCCESS,
    REQUEST_TO_JOIN,
    REQUEST_TO_JOIN_FAILURE,
    REQUEST_TO_JOIN_SUCCESS,
} from '../actions/club-actions';
import { ComparatorTypes, comparator } from '../utils/comparator';
import { mapClubMemberV2ToV1 } from '../utils/mapping/clubs';

const _ = { cloneDeep, findIndex, map };

const initialState = {
    isLoading: false,
    isSaving: false,
    isLoadingEvents: false,
    isClubCreated: false,
    isClubUpdated: false,
    addedAdmins: false,
    membersInvited: false,
    createdClubId: null,
    rows: [],
    clubId: null,
    resultsType: 's',
    results: null,
    clubDetails: null,
    clubDetailsFetched: false,
    members: [],
    schoolDetails: null,
    schoolDetailsState: {
        loading: false,
        complete: false,
        successful: false,
        errorMessage: null,
    },
    tmsEventsFetchState: {
        loading: false,
        completed: false,
        successful: false,
        errorMessage: null,
        eventsFetched: 0,
        eventsNextStart: 0,
        eventsListExhausted: false,
        draftEventsFetched: 0,
        count: 10,
        officialHsEventsFetched: 0,
        otherHsEventsFetched: 0,
        otherHsDraftEventsFetched: 0,
    },
    clubMembersFetchState: {
        loading: false,
        completed: false,
        successful: false,
        errorMessage: null,
        searchParams: {
            skip: 0,
        },
        selectedMembers: [],
        selectedMemberIds: [],
        selectAllMembers: false,
        deletedMembers: [],
        updatedMembers: [],
    },
    resultsFetchState: {
        loading: false,
        completed: false,
        successful: false,
        errorMessage: null,
        start: 0,
        draftEventsStart: 0,
        count: clubs.resultsDefaultPageSize,
        totalResultsFetched: 0,
    },
    metaData: {},
    power6StatsState: {
        loading: false,
        completed: false,
        successful: false,
        errorMessage: null,
    },
    power6Stats: null,
    clubLocations: [],
    highSchoolStandingsState: {
        loading: false,
        completed: false,
        successful: false,
        errorMessage: null,
    },
    highSchoolStandings: null,
    highSchoolStandingsSeasons: [],
    adultTeamTennisRosterState: {
        loading: false,
        completed: false,
        successful: false,
        errorMessage: null,
    },
    adultTeamTennisRoster: [],
    adultTeamTennisEventsState: {
        loading: false,
        completed: false,
        successful: false,
        errorMessage: null,
    },
    adultTeamTennisEvents: {
        upcomingEvents: [],
        pastEvents: [],
    },
    adultTeamTennisStandingsState: {
        loading: false,
        completed: false,
        successful: false,
        errorMessage: null,
    },
    adultTeamTennisStandings: [],
    clubTeamRatingsState: {
        loading: false,
        completed: false,
        successful: false,
        errorMessage: null,
    },
    clubTeamRatings: null,
    eventSponsorLogoUrlTemp: '',
};

const comparatorParams = [
    {
        type: ComparatorTypes.DATE,
        field: 'momentStartDate',
        descend: true,
    },
    {
        type: ComparatorTypes.STRING,
        field: 'name',
    },
];
const upcomingComparatorParams = [
    {
        type: ComparatorTypes.DATE,
        field: 'momentStartDate',
    },
    {
        type: ComparatorTypes.STRING,
        field: 'name',
    },
];

const now = moment();
function updateFetchState(state, action) {
    const deletedMembers = _.cloneDeep(state.clubMembersFetchState.deletedMembers);
    const updatedMembers = _.cloneDeep(state.clubMembersFetchState.updatedMembers);
    if (action?.data?.updatedMembers) {
        let updatedClubMemberIndex = -1;
        if (Array.isArray(action.data.updatedMembers)) {
            action.data.updatedMembers.forEach(updatedMember => {
                updatedClubMemberIndex = _.findIndex(updatedMembers, { memberId: updatedMember.memberId });
                if (updatedClubMemberIndex !== -1) {
                    updatedMembers.splice(updatedClubMemberIndex, 1);
                }
                updatedMembers.push(updatedMember);
            });
        } else {
            updatedClubMemberIndex = _.findIndex(updatedMembers, { memberId: action.data.updatedMembers.memberId });
            if (updatedClubMemberIndex !== -1) {
                updatedMembers.splice(updatedClubMemberIndex, 1);
            }
            updatedMembers.push(action.data.updatedMembers);
        }
    }

    if (action?.data?.deletedMembers) {
        let deletedClubMemberIndex = -1;
        if (Array.isArray(action.data.deletedMembers)) {
            action.data.deletedMembers.forEach(deletedMember => {
                deletedClubMemberIndex = _.findIndex(deletedMembers, { memberId: deletedMember.memberId });
                if (deletedClubMemberIndex === -1) {
                    deletedMembers.push(deletedMember);
                }
            });
        } else {
            deletedClubMemberIndex = _.findIndex(deletedMembers, { memberId: action.data.deletedMembers.memberId });
            if (deletedClubMemberIndex === -1) {
                deletedMembers.push(action.data.deletedMembers);
            }
        }
    }

    return { deletedMembers, updatedMembers };
}

function updateClubMembers(state, data) {
    const clubMembers = data.hits
        .map(member => mapClubMemberV2ToV1(member, state.clubId))
        .filter((member) => member.role !== 'FormerMember' && member.role !== 'FormerFollower');

    const { updatedMembers } = state.clubMembersFetchState;

    if (Array.isArray(updatedMembers)) {
        updatedMembers.forEach(updatedMember => {
            const clubMemberIndex = _.findIndex(clubMembers, { memberId: updatedMember.memberId });
            if (clubMemberIndex !== -1) {
                clubMembers[clubMemberIndex].clubMemberRoleId = updatedMember.clubMemberRoleId;
                clubMembers[clubMemberIndex].role = updatedMember.role;
                clubMembers[clubMemberIndex].clubMemberTypeId = updatedMember.clubMemberTypeId;
                clubMembers[clubMemberIndex].isPower = updatedMember.isPower;
            }
        });
    }
    return clubMembers;
}

function updateTeamMatches(state, eventId, param, value) {
    const teamMatches = _.cloneDeep(state.clubDetails?.teamMatches);
    const teamMatchesUpcoming = _.cloneDeep(state.clubDetails?.teamMatchesUpcoming);
    const teamMatchesRecent = _.cloneDeep(state.clubDetails?.teamMatchesRecent);

    const teammatchesIndex = _.findIndex(teamMatches, { id: eventId });
    const teamMatchesUpcomingIndex = _.findIndex(teamMatchesUpcoming, { id: eventId });
    const teamMatchesRecentIndex = _.findIndex(teamMatchesRecent, { id: eventId });

    if (teammatchesIndex !== -1) {
        teamMatches[teammatchesIndex][param] = value;
    }
    if (teamMatchesUpcomingIndex !== -1) {
        teamMatchesUpcoming[teamMatchesUpcomingIndex][param] = value;
    }
    if (teamMatchesRecentIndex !== -1) {
        teamMatchesRecent[teamMatchesRecentIndex][param] = value;
    }

    return { teamMatches, teamMatchesUpcoming, teamMatchesRecent };
}

function updateTeamMatchesPublished(state, eventId, published) {
    return updateTeamMatches(state, eventId, 'published', published);
}

function updateTeamMatchesIsConference(state, eventId, isConference) {
    return updateTeamMatches(state, eventId, 'isConference', isConference);
}

function deleteTeamMatch(state, eventId) {
    const teamMatches = _.cloneDeep(state.clubDetails?.teamMatches);
    const teamMatchesUpcoming = _.cloneDeep(state.clubDetails?.teamMatchesUpcoming);
    const teamMatchesRecent = _.cloneDeep(state.clubDetails?.teamMatchesRecent);

    const teammatchesIndex = _.findIndex(teamMatches, { id: eventId });
    const teamMatchesUpcomingIndex = _.findIndex(teamMatchesUpcoming, { id: eventId });
    const teamMatchesRecentIndex = _.findIndex(teamMatchesRecent, { id: eventId });

    if (teammatchesIndex !== -1) {
        teamMatches.splice(teammatchesIndex, 1);
    }
    if (teamMatchesUpcomingIndex !== -1) {
        teamMatchesUpcoming.splice(teamMatchesUpcomingIndex, 1);
    }
    if (teamMatchesRecentIndex !== -1) {
        teamMatchesRecent.splice(teamMatchesRecentIndex, 1);
    }

    return { teamMatches, teamMatchesUpcoming, teamMatchesRecent };
}

function updateClubEvent(state, event) {
    const tmsEventsRecent = _.cloneDeep(state.clubDetails?.tmsEventsRecent || []);
    let tmsEventsUpcoming = _.cloneDeep(state.clubDetails?.tmsEventsUpcoming || []);
    let draftEvents = _.cloneDeep(state.clubDetails?.draftEvents || []);
    let { eventsFetched, draftEventsFetched } = state.tmsEventsFetchState;
    const isHighSchool = state.clubDetails?.tierType?.isHighSchool;

    const tmsEventsRecentIndex = _.findIndex(tmsEventsRecent, { id: event.id });
    const tmsEventsUpcomingIndex = _.findIndex(tmsEventsUpcoming, { id: event.id });
    const draftEventsIndex = _.findIndex(draftEvents, { id: event.id });

    if (tmsEventsRecentIndex !== -1) {
        tmsEventsRecent[tmsEventsRecentIndex] = {
            ...tmsEventsRecent[tmsEventsRecentIndex],
            ...event,
        };
    } else if (tmsEventsUpcomingIndex !== -1) {
        tmsEventsUpcoming[tmsEventsUpcomingIndex] = {
            ...tmsEventsUpcoming[tmsEventsUpcomingIndex],
            ...event,
        };
    } else if (draftEventsIndex !== -1) {
        draftEvents[draftEventsIndex] = {
            ...draftEvents[draftEventsIndex],
            ...event,
        };
    } else {
        // new event
        tmsEventsUpcoming.push(event);
        tmsEventsUpcoming = tmsEventsUpcoming.sort(comparator(upcomingComparatorParams));
        if (isHighSchool || event.published === true) {
            eventsFetched += 1;
        }

        if (!event.published) {
            draftEvents.push(event);
            draftEvents = draftEvents.sort(comparator(comparatorParams));
            draftEventsFetched += 1;
        }
    }

    return { tmsEventsRecent, tmsEventsUpcoming, draftEvents, eventsFetched, draftEventsFetched };
}

function app(state = initialState, action) {
    switch (action.type) {
        case 'CLUBS:CREATE':
            return {
                ...state,
                isLoading: true,
                createError: false,
                createErrorMessage: null,
            };
        case 'CLUBS:CREATE_SUCCESS':
            return {
                ...state,
                isLoading: false,
                isClubCreated: true,
                createdClubId: action.data.id,
                createError: false,
                createErrorMessage: null,
            };
        case 'CLUBS:DELETE_INVITE_SUCCESS':
            return {
                ...state,
                clubDetails: action.data.clubDetails,
            };
        case 'CLUBS:CREATE_FAILURE':
            return {
                ...state,
                isLoading: false,
                createError: true,
                createErrorMessage: action.errorMessage || null,
            };
        case 'CLUBS:UPDATE':
            return {
                ...state,
                isLoading: true,
            };
        case 'CLUBS:UPDATE_SUCCESS': {
            return {
                ...state,
                isLoading: false,
                isClubUpdated: true,
                createdClubId: action.data.id,
                clubDetails: {
                    ...action.data,
                    clubMemberRequests: state.clubDetails.clubMemberRequests,
                    currentMember: state.clubDetails.currentMember,
                },
            };
        }

        case 'CLUBS:UPDATE_FAILURE':
        case 'CLUBS:GET_ALL_CLUBS':
        case 'CLUBS:GET_ALL_CLUBS_FAILURE':
        case 'CLUBS:ADD_CLUB_MEMBERS':
        case 'CLUBS:INVITE_CLUB_MEMBERS':
        case 'CLUBS:INVITE_CLUB_MEMBERS_FAILURE':
        case 'CLUBS:ADD_CLUB_MEMBERS_FAILURE':
        case 'CLUBS:UPDATE_MEMBER_ROLE':
        case 'CLUBS:UPDATE_MEMBER_ROLE_FAILURE':
            return {
                ...state,
                isLoading: false,
            };
        case 'CLUBS:GET_ALL_CLUBS_SUCCESS':
            return {
                ...state,
                isLoading: false,
                rows: action.data,
            };
        case 'CLUBS:SET_CLUB_ID':
            return {
                ...state,
                clubId: action.clubId,
                clubDetails: null,
                clubDetailsFetched: false,
                isClubUpdated: false,
                schoolDetails: null,
                schoolDetailsState: {
                    loading: false,
                    complete: false,
                    successful: false,
                    errorMessage: null,
                },
            };
        case 'CLUBS:CLEAR_SPLASH_PROPS':
            return {
                ...state,
                isClubCreated: false,
                isClubUpdated: false,
                addedAdmins: false,
                membersInvited: false,
            };
        case 'CLUBS:GET_CLUB_DETAILS':
            return {
                ...state,
                isLoading: true,
                clubDetails: null,
                clubDetailsFetched: false,
                schoolDetails: null,
                schoolDetailsState: {
                    loading: false,
                    complete: false,
                    successful: false,
                    errorMessage: null,
                },
            };
        case 'CLUBS:GET_CLUB_DETAILS_FAILURE':
            return {
                ...state,
                isLoading: false,
                clubDetails: null,
                clubDetailsFetched: true,
            };
        case 'CLUBS:GET_CLUB_DETAILS_SUCESS':
            const clubDetails = action.data;
            const utcNow = moment.utc();
            clubDetails.tmsEvents.forEach(event => {
                event.momentStartDate = moment.utc(event.eventSchedule.eventStartUtc);
                event.momentEndDate = moment.utc(event.eventSchedule.eventEndUtc);
            });
            clubDetails.teamMatches.forEach(event => {
                event.momentStartDate = moment(event.startDate);
                event.momentEndDate = moment(event.endDate);
            });

            clubDetails.tmsEventsRecent = clubDetails.tmsEvents.filter(event => event.momentEndDate < utcNow).sort(comparator(comparatorParams));
            clubDetails.tmsEventsUpcoming = clubDetails.tmsEvents.filter(event => event.momentEndDate >= utcNow).sort(comparator(upcomingComparatorParams));
            clubDetails.teamMatchesRecent = clubDetails.teamMatches.filter(event => event.momentEndDate < now).sort(comparator(comparatorParams));
            clubDetails.teamMatchesUpcoming = clubDetails.teamMatches.filter(event => event.momentEndDate >= now).sort(comparator(upcomingComparatorParams));
            clubDetails.draftEvents = (clubDetails?.unpublishedEvents?.sort(comparator(comparatorParams))) || [];

            clubDetails.tmsEventsCount = clubDetails.eventCount;
            clubDetails.draftEventsCount = clubDetails.draftEventCount;
            clubDetails.eventCount += clubDetails.teamMatches.length;
            const { isHighSchool } = clubDetails.tierType;

            // Calculate eventsNextStart: the count of loaded events that form a
            // contiguous block from position 0 in the flat list (eventStartUtc DESC).
            // The initial load has ALL upcoming events + top-5 recent events.
            // All events with startUtc >= the oldest recent event's startUtc are
            // guaranteed to be loaded, so we can safely skip them in /events/list.
            let eventsNextStart = 0;
            const recentWithStartDate = clubDetails.tmsEventsRecent.filter(e => e.momentStartDate);
            if (recentWithStartDate.length > 0) {
                const oldestRecentStartMs = Math.min(
                    ...recentWithStartDate.map(e => e.momentStartDate.valueOf()),
                );
                eventsNextStart = clubDetails.tmsEvents.filter(
                    e => e.momentStartDate && e.momentStartDate.valueOf() >= oldestRecentStartMs,
                ).length;
            } else if (clubDetails.tmsEventsUpcoming.length > 0) {
                // No past events loaded; all loaded events are upcoming
                eventsNextStart = clubDetails.tmsEventsUpcoming.length;
            } else {
                // No events loaded; eventsNextStart remains 0
            }

            return {
                ...state,
                isLoading: false,
                clubDetails,
                isClubUpdated: false,
                clubDetailsFetched: true,
                tmsEventsFetchState: {
                    ...(state.tmsEventsFetchState),
                    eventsFetched: clubDetails.tmsEvents.filter(e => (isHighSchool ? e : e.published === true)).length, // remove draft events as they are included in draftEventsFetched
                    eventsNextStart,
                    eventsListExhausted: false,
                    draftEventsFetched: (clubDetails?.unpublishedEvents?.length) || 0,
                },
            };
        case 'CLUBS:GET_CLUB_EVENTS':
            return {
                ...state,
                tmsEventsFetchState: {
                    loading: true,
                    complete: false,
                    successful: false,
                    errorMessage: null,
                },
                tmsEventsRecent: [],
                tmsEventsUpcoming: [],
            };
        case 'CLUBS:GET_CLUB_EVENTS_SUCESS':
            return {
                ...state,
                clubDetails: {
                    ...(state.clubDetails),
                    tmsEventsRecent: action.data.tmsEventsRecent,
                    tmsEventsUpcoming: action.data.tmsEventsUpcoming,
                },
                tmsEventsFetchState: {
                    ...(state.tmsEventsFetchState),
                    loading: false,
                    complete: true,
                    successful: true,
                    errorMessage: null,
                    eventsFetched: action.data.eventsFetched,
                    eventsNextStart: action.data.eventsNextStart,
                    eventsListExhausted: action.data.eventsListExhausted,
                    officialHsEventsFetched: action.data.officialHsEventsFetched,
                    otherHsEventsFetched: action.data.otherHsEventsFetched,
                },
            };
        case 'CLUBS:GET_CLUB_EVENTS_FAILURE':
        case 'CLUBS:GET_DRAFT_CLUB_EVENTS_FAILURE':
            return {
                ...state,
                tmsEventsFetchState: {
                    ...(state.tmsEventsFetchState),
                    loading: false,
                    complete: true,
                    successful: false,
                    errorMessage: 'Failed to load events',
                },
            };
        case 'CLUBS:GET_DRAFT_CLUB_EVENTS_SUCESS':
            return {
                ...state,
                clubDetails: {
                    ...(state.clubDetails),
                    draftEvents: action.data.draftEvents,
                },
                tmsEventsFetchState: {
                    ...(state.tmsEventsFetchState),
                    loading: false,
                    complete: true,
                    successful: true,
                    errorMessage: null,
                    draftEventsFetched: action.data.draftEvents.length,
                    otherHsDraftEventsFetched: action.data.otherHsDraftEventsFetched,
                },
            };
        case 'CLUBS:ADD_CLUB_MEMBERS_SUCCESS':
            return {
                ...state,
                isLoading: false,
                addedAdmins: action.data.addedAdmins,
            };
        case 'CLUBS:INVITE_CLUB_MEMBERS_SUCCESS':
            const invitedCount = action.data.data.filter(i => i.invited).length;
            return {
                ...state,
                isLoading: false,
                membersInvited: action.data.membersInvited,
                clubDetails: {
                    ...state.clubDetails,
                    availableMemberSlots: state.clubDetails.availableMemberSlots >= 0
                        ? Math.max(0, state.clubDetails.availableMemberSlots - invitedCount)
                        : state.clubDetails.availableMemberSlots,
                },
            };
        case 'CLUBS:ADD_CLUB_MEMBER_REQUEST':
            return {
                ...state,
                validationMessage: null,
            };
        case 'CLUBS:ADD_CLUB_MEMBER_FAILURE':
            return {
                ...state,
                validationMessage: action.data.error || null,
            };
        case 'CLUBS:ADD_CLUB_MEMBER_SUCCESS':
            return {
                ...state,
                isLoading: false,
                validationMessage: null,
                clubDetails: {
                    ...state.clubDetails,
                    availableMemberSlots: state.clubDetails.availableMemberSlots >= 0
                        ? Math.max(0, state.clubDetails.availableMemberSlots - 1)
                        : state.clubDetails.availableMemberSlots,
                    availableAdminSlots: action.data.role === 'admin' && state.clubDetails.availableAdminSlots >= 0
                        ? Math.max(0, state.clubDetails.availableAdminSlots - 1)
                        : state.clubDetails.availableAdminSlots,
                    availableOwnerSlots: action.data.role === 'owner' && state.clubDetails.availableOwnerSlots >= 0
                        ? Math.max(0, state.clubDetails.availableOwnerSlots - 1)
                        : state.clubDetails.availableOwnerSlots,
                },
            };
        case 'CLUBS:UPDATE_MEMBER_ROLE_SUCCESS':
            return {
                ...state,
                isLoading: false,
                clubDetails: _.cloneDeep(action.data.clubDetails),
                members: _.cloneDeep(action.data.members),
            };
        case 'CLUBS:UPDATE_MEMBER_TYPE':
            return {
                ...state,
                isLoading: true,
            };
        case 'CLUBS:UPDATE_MEMBER_TYPE_FAILURE':
            return {
                ...state,
                isLoading: false,
            };
        case 'CLUBS:UPDATE_MEMBER_TYPE_SUCCESS':
            return {
                ...state,
                isLoading: false,
                clubDetails: _.cloneDeep(action.data.clubDetails),
                members: _.cloneDeep(action.data.members),
            };
        case 'CLUBS:UPDATE_MEMBER_POWER':
            return {
                ...state,
                isLoading: true,
            };
        case 'CLUBS:UPDATE_MEMBER_POWER_FAILURE':
            return {
                ...state,
                isLoading: false,
            };
        case 'CLUBS:UPDATE_MEMBER_POWER_SUCCESS':
            return {
                ...state,
                isLoading: false,
                clubDetails: _.cloneDeep(action.data.clubDetails),
                members: _.cloneDeep(action.data.members),
            };
        case 'CLUBS:GET_MEMBERS':
        case CLUBS_SEARCH_MEMBERS:
        case CLUBS_REMOVE_MEMBERS:
        case CLUBS_CHANGE_MEMBERSHIP_TYPE:
            return {
                ...state,
                clubMembersFetchState: {
                    ...state.clubMembersFetchState,
                    loading: true,
                    complete: false,
                    successful: false,
                    errorMessage: null,
                    searchParams: action.searchParams,
                },
            };
        case 'CLUBS:GET_MEMBERS_FAILURE':
        case CLUBS_SEARCH_MEMBERS_FAILURE:
            return {
                ...state,
                clubMembersFetchState: {
                    ...state.clubMembersFetchState,
                    loading: false,
                    complete: true,
                    successful: false,
                    errorMessage: 'Failed to load club Members',
                },
            };
        case 'CLUBS:GET_MEMBERS_SUCCESS':
            return {
                ...state,
                clubDetails: {
                    ...(state.clubDetails),
                    clubMembers: action.data.filter((member) => member.role !== 'FormerMember' && member.role !== 'FormerFollower'),
                },
                clubMembersFetchState: {
                    ...state.clubMembersFetchState,
                    loading: false,
                    complete: true,
                    successful: true,
                    errorMessage: null,
                },
            };
        case CLUBS_SEARCH_MEMBERS_SUCCESS:
            return {
                ...state,
                clubDetails: {
                    ...(state.clubDetails),
                    clubMembers: updateClubMembers(state, action.data),
                    clubMembersTotal: action.data.total,
                },
                clubMembersFetchState: {
                    ...state.clubMembersFetchState,
                    loading: false,
                    complete: true,
                    successful: true,
                    errorMessage: null,
                },
            };
        case CLUBS_REMOVE_MEMBERS_FAILURE:
            return {
                ...state,
                clubMembersFetchState: {
                    ...state.clubMembersFetchState,
                    loading: false,
                    complete: true,
                    successful: false,
                    errorMessage: 'Failed to remove club Members',
                },
            };
        case CLUBS_CHANGE_MEMBERSHIP_TYPE_FAILURE:
            return {
                ...state,
                clubMembersFetchState: {
                    ...state.clubMembersFetchState,
                    loading: false,
                    complete: true,
                    successful: false,
                    errorMessage: 'Failed to change club membership type',
                },
            };

        case 'CLUBS:GET_INVITES_SUCCESS':
            return {
                ...state,
                clubDetails: {
                    ...(state.clubDetails),
                    clubMemberInvites: action.invites,
                },
            };
        case 'CLUBS:ACCEPT_REJECT_REQUEST':
            return {
                ...state,
                isLoading: true,
            };
        case 'CLUBS:ACCEPT_REJECT_REQUEST_FAILURE':
            return {
                ...state,
                isLoading: false,
            };
        case 'CLUBS:ACCEPT_REJECT_REQUEST_SUCCESS':
            return {
                ...state,
                isLoading: false,
                clubDetails: _.cloneDeep(action.data.clubDetails),
                members: _.cloneDeep(action.data.members),
            };
        case 'CLUBS:CROP_BANNER_PHOTO_SUCCESS':
            return {
                ...state,
                clubDetails: {
                    ...state.clubDetails,
                    bannerUrl: action.res.data.bannerUrl,
                },
            };
        case 'CLUBS:REMOVE_BANNER_PHOTO_SUCCESS':
            return {
                ...state,
                clubDetails: {
                    ...state.clubDetails,
                    bannerUrl: null,
                },
            };
        case 'CLUBS:SUBMIT_GALLERY_PHOTO_SUCCESS':
            if (!state.clubDetails) {
                return state;
            }
            return {
                ...state,
                clubDetails: {
                    ...state.clubDetails,
                    photoCount: parseInt(state.clubDetails.photoCount) + 1,
                },
            };
        case 'CLUBS:REMOVE_GALLERY_PHOTOS_SUCCESS':
            return {
                ...state,
                clubDetails: {
                    ...state.clubDetails,
                    photoCount: action.res.data.photos.length,
                },
            };
        case REQUEST_TO_JOIN:
        case 'CLUBS:REQUEST_TO_UNFOLLOW':
            return {
                ...state,
                isSaving: true,
            };
        case REQUEST_TO_JOIN_SUCCESS:
            return {
                ...state,
                isSaving: false,
                clubDetails: action.data.clubDetails,
            };
        case REQUEST_TO_JOIN_FAILURE:
        case 'CLUBS:REQUEST_TO_UNFOLLOW_FAILURE':
            return {
                ...state,
                isSaving: false,
            };
        case 'CLUBS:REQUEST_TO_UNFOLLOW_SUCCESS':
            const { memberId } = action.data;
            let clubMembers;
            const clubMemberIndex = _.findIndex(state.clubDetails.clubMembers, { memberId });
            console.log('clubMembers', state.clubDetails.clubMembers);
            console.log('clubMemberIndex', clubMemberIndex);
            if (clubMemberIndex !== -1) {
                clubMembers = [...state.clubDetails.clubMembers];
                clubMembers.splice(clubMemberIndex, 1);
            }
            const { role } = state.clubDetails.currentMember;
            return {
                ...state,
                isSaving: false,
                clubDetails: {
                    ...state.clubDetails,
                    currentMember: {},
                    memberCount: state.clubDetails.memberCount - 1,
                    ...(clubMembers ? { clubMembers } : {}),
                    ...(state.clubDetails.availableMemberSlots >= 0 ? { availableMemberSlots: state.clubDetails.availableMemberSlots + 1 } : {}),
                    ...(role === 'Admin' ? { availableAdminSlots: state.clubDetails.availableAdminSlots + 1 } : {}),
                    ...(role === 'Owner' ? { availableOwnerSlots: state.clubDetails.availableOwnerSlots + 1 } : {}),
                },
            };
        case 'CLUBS:CROP_SPONSOR_LOGO_SUCCESS':
            return {
                ...state,
                clubDetails: {
                    ...state.clubDetails,
                    sponsorLogoUrl: action.res.data.sponsorLogoUrl,
                },
            };
        case 'EVENTS:CROP_EVENT_SPONSOR_LOGO_SUCCESS':
            return {
                ...state,
                eventSponsorLogoUrlTemp: action.res.data.sponsorUrl,
            };
        case 'CLUBS:REMOVE_SPONSOR_LOGO_SUCCESS':
            return {
                ...state,
                clubDetails: {
                    ...state.clubDetails,
                    sponsorLogoUrl: null,
                },
            };
        case 'CLUBS:APPLY_FOR_VERIFIED_SUCCESS':
            return {
                ...state,
                clubDetails: {
                    ...state.clubDetails,
                    verificationApplicationStatus: action.res.data.verificationApplicationStatus,
                },
            };
        case 'CLUBS:APPLY_FOR_AUTO_VERIFIED_SUCCESS':
            return {
                ...state,
                clubDetails: {
                    ...state.clubDetails,
                    verificationApplicationStatus: action.res.data.verificationApplicationStatus,
                    sanctioned: true,
                },
            };
        case CLUB_GET_SCHOOL_DETAILS:
            return {
                ...state,
                schoolDetails: null,
                schoolDetailsState: {
                    loading: true,
                    complete: false,
                    successful: false,
                    errorMessage: null,
                },
            };
        case CLUB_GET_SCHOOL_DETAILS_SUCCESS:
            return {
                ...state,
                schoolDetails: action.data.schoolDetails,
                schoolDetailsState: {
                    loading: false,
                    complete: true,
                    successful: true,
                    errorMessage: null,
                },
            };
        case CLUB_GET_SCHOOL_DETAILS_FAILURE:
            return {
                ...state,
                schoolDetails: null,
                schoolDetailsState: {
                    loading: false,
                    complete: true,
                    successful: false,
                    errorMessage: 'Failed to club Schools',
                },
            };
        case 'CLUB:ADD_TEAM_ROLES':
            return {
                ...state,
                isLoading: true,
            };
        case 'CLUB:ADD_TEAM_ROLES_SUCCESS':
            return {
                ...state,
                isLoading: false,
                clubDetails: {
                    ...state.clubDetails,
                    teamRoles: action.data,
                },
            };
        case 'CLUB:ADD_TEAM_ROLES_FAILURE':
            return {
                ...state,
                isLoading: false,
            };
        case 'CLUB:REMOVE_TEAM_ROLE':
            return {
                ...state,
                isLoading: true,
            };
        case 'CLUB:REMOVE_TEAM_ROLE_SUCCESS':
            return {
                ...state,
                isLoading: false,
                clubDetails: {
                    ...state.clubDetails,
                    teamRoles: action.data,
                },
            };
        case 'CLUB:REMOVE_TEAM_ROLE_FAILURE':
            return {
                ...state,
                isLoading: false,
            };
        case 'CLUB:ADD_UPDATE_PLAYER_ON_ROSTER':
            return {
                ...state,
                isLoading: true,
            };
        case 'CLUB:UPDATE_PLAYER_CLASS_YEAR_IN_ROSTER':
            // Optimistically update just the specific player's classYearStatus in the roster
            if (!state.schoolDetails?.roster) {
                return state;
            }

            let playerMatched = false;
            const updatedRoster = state.schoolDetails.roster.map((player) => {
                const isMatch = player.id === action.playerId;

                if (isMatch) {
                    playerMatched = true;
                    const updatedPlayer = {
                        ...player,
                    };
                    if (!!action.classYearStatus) {
                        updatedPlayer.classYearStatus = action.classYearStatus;
                    }
                    if (action.redshirt !== undefined) {
                        updatedPlayer.redshirt = action.redshirt;
                    }
                    return updatedPlayer;
                }
                return player;
            });

            if (!playerMatched) {
                // Player not found in roster
            }

            return {
                ...state,
                schoolDetails: {
                    ...state.schoolDetails,
                    roster: updatedRoster,
                },
            };
        case 'CLUB:UPDATE_PLAYER_REDSHIRT_STATUS_IN_ROSTER':
            // Optimistically update just the specific player's redshirt status in the roster
            if (!state.schoolDetails?.roster) {
                return state;
            }

            let redshirtPlayerMatched = false;
            const updatedRedshirtRoster = state.schoolDetails.roster.map((player) => {
                const isMatch = player.id === action.playerId;

                if (isMatch) {
                    redshirtPlayerMatched = true;
                    const updatedPlayer = {
                        ...player,
                    };
                    if (!!action.classYearStatus) {
                        updatedPlayer.classYearStatus = action.classYearStatus;
                    }
                    if (action.redshirt !== undefined) {
                        updatedPlayer.redshirt = action.redshirt;
                    }
                    return updatedPlayer;
                }
                return player;
            });

            if (!redshirtPlayerMatched) {
                // Player not found in roster for redshirt update
            }

            return {
                ...state,
                schoolDetails: {
                    ...state.schoolDetails,
                    roster: updatedRedshirtRoster,
                },
            };
        case 'CLUB:ADD_PLAYER_TO_ROSTER_OPTIMISTIC':
            // Optimistically add the player to the roster array
            if (!state.schoolDetails?.roster) {
                return state;
            }

            // Check if player already exists in roster (avoid duplicates)
            // Match by roster player id (id field) - this is the primary key and most reliable
            const playerExists = state.schoolDetails.roster.some((player) => (
                player.id && action.player.id && player.id === action.player.id
            ));

            if (playerExists) {
                // Player already exists, just update rosterCount if needed
                return {
                    ...state,
                    schoolDetails: {
                        ...state.schoolDetails,
                        rosterCount: action.rosterCount != null ? action.rosterCount : state.schoolDetails.roster.length,
                    },
                };
            }

            // Add the new player to the roster
            const updatedRosterWithNewPlayer = [...state.schoolDetails.roster, action.player];

            return {
                ...state,
                schoolDetails: {
                    ...state.schoolDetails,
                    roster: updatedRosterWithNewPlayer,
                    rosterCount: action.rosterCount != null ? action.rosterCount : updatedRosterWithNewPlayer.length,
                },
            };
        case 'CLUB:UPDATE_PLAYER_IN_ROSTER':
            // Update a player in the roster (e.g., replace minimal player with full data from background fetch)
            if (!state.schoolDetails?.roster) {
                return state;
            }

            const updatedRosterWithReplacedPlayer = state.schoolDetails.roster.map((player) => {
                // Match by the oldPlayerId (temporary ID used when adding) or by profileId
                const matchesOldPlayerId = action.oldPlayerId && (
                    player.id === action.oldPlayerId ||
                    player.profileId === action.oldPlayerId ||
                    player.playerId === action.oldPlayerId
                );
                const matchesProfileId = action.newPlayer.profileId && player.profileId === action.newPlayer.profileId;
                const matchesId = action.newPlayer.id && player.id === action.newPlayer.id;

                const isMatch = matchesOldPlayerId || matchesProfileId || matchesId;

                if (isMatch) {
                    return action.newPlayer;
                }
                return player;
            });

            return {
                ...state,
                schoolDetails: {
                    ...state.schoolDetails,
                    roster: updatedRosterWithReplacedPlayer,
                    rosterCount: action.rosterCount != null ? action.rosterCount : updatedRosterWithReplacedPlayer.length,
                },
            };
        case 'CLUB:ADD_UPDATE_PLAYER_ON_ROSTER_SUCCESS':
            // If action.data is provided (old API), use it
            if (action.data && Array.isArray(action.data) && action.data.length > 0) {
                return {
                    ...state,
                    isLoading: false,
                    schoolDetails: {
                        ...state.schoolDetails,
                        rosterCount: action.data.length,
                        roster: action.data,
                    },
                };
            }
            // For new API, player was already added via CLUB:ADD_PLAYER_TO_ROSTER_OPTIMISTIC
            // The roster array reference was already updated in that action, so we just need to update isLoading
            // and create a new schoolDetails reference to ensure React detects the change
            // We need to create a new roster array reference as well to ensure React detects the change
            return {
                ...state,
                isLoading: false,
                schoolDetails: state.schoolDetails ? {
                    ...state.schoolDetails,
                    roster: state.schoolDetails.roster ? [...state.schoolDetails.roster] : state.schoolDetails.roster,
                } : state.schoolDetails,
            };
        case 'CLUB:ADD_UPDATE_PLAYER_ON_ROSTER_FAILURE':
            return {
                ...state,
                isLoading: false,
            };
        case 'CLUB:REMOVE_PLAYER_FROM_ROSTER':
            return {
                ...state,
                isLoading: true,
            };
        case 'CLUB:REMOVE_PLAYER_FROM_ROSTER_OPTIMISTIC':
            // Optimistically remove the player from the roster array
            if (!state.schoolDetails?.roster) {
                return state;
            }

            // Filter out the player to remove (match by roster player id, profileId, or memberId)
            const filteredRoster = state.schoolDetails.roster.filter((player) => {
                const isMatch = player.id === action.playerId ||
                    player.profileId === action.playerId ||
                    player.memberId === action.playerId ||
                    player.playerId === action.playerId;
                return !isMatch;
            });

            return {
                ...state,
                schoolDetails: {
                    ...state.schoolDetails,
                    roster: filteredRoster,
                    rosterCount: filteredRoster.length,
                },
            };
        case 'CLUB:REMOVE_PLAYER_FROM_ROSTER_SUCCESS':
            // If action.data is provided (old API), use it
            if (action.data && Array.isArray(action.data)) {
                return {
                    ...state,
                    isLoading: false,
                    schoolDetails: {
                        ...state.schoolDetails,
                        rosterCount: action.data.length,
                        roster: action.data,
                    },
                };
            }
            // For new API, player was already removed via CLUB:REMOVE_PLAYER_FROM_ROSTER_OPTIMISTIC
            // The roster array reference was already updated in that action, so we just need to update isLoading
            // and create a new schoolDetails reference to ensure React detects the change
            return {
                ...state,
                isLoading: false,
                schoolDetails: state.schoolDetails ? {
                    ...state.schoolDetails,
                } : state.schoolDetails,
            };
        case 'CLUB:REMOVE_PLAYER_FROM_ROSTER_FAILURE':
            return {
                ...state,
                isLoading: false,
            };
        case 'CLUBS:CROP_PROFILE_PHOTO_SUCCESS':
            return {
                ...state,
                clubDetails: {
                    ...state.clubDetails,
                    profilePhotoUrl: action.res.data.profilePhotoUrl,
                    clubProfileImages: {
                        default: action.res.data.profilePhotoUrl,
                    },
                },
            };
        case 'CLUBS:REMOVE_PROFILE_PHOTO_SUCCESS':
            return {
                ...state,
                clubDetails: {
                    ...state.clubDetails,
                    profilePhotoUrl: null,
                    clubProfileImages: null,
                },
            };
        case 'CLUBS:CHANGE_RESULT_TYPE':
            return {
                ...state,
                resultsType: action.resultsType === 'doubles' ? 'd' : 's',
                results: null,
            };
        case 'CLUBS:FETCH_RESULTS_REQUEST':
            return {
                ...state,
                resultsFetchState: {
                    loading: true,
                    complete: false,
                    successful: false,
                    errorMessage: null,
                },
            };
        case 'CLUBS:FETCH_RESULTS_SUCCESS':
            return {
                ...state,
                resultsFetchState: {
                    ...(state.resultsFetchState),
                    loading: false,
                    complete: true,
                    successful: true,
                    errorMessage: null,
                    count: action.data.count,
                    start: action.data.start,
                    totalResultsFetched: action.data.totalResultsFetched,
                },
                results: action.data.results,
            };
        case 'CLUBS:FETCH_RESULTS_FAILURE':
            return {
                ...state,
                resultsFetchState: {
                    ...(state.resultsFetchState),
                    loading: false,
                    complete: true,
                    successful: false,
                    errorMessage: 'Failed to load Results',
                },
            };
        case 'POST_SCORE:DELETE_SCORE_SUCCESS':
            const { resultId } = action.data;
            const results = _.cloneDeep(state.results);
            let resultIndex = -1;
            if (results && results.events && results.events.length > 0) {
                results.events.forEach((event) => {
                    if (event.draws && event.draws.results && event.draws.results.length > 0) {
                        resultIndex = _.findIndex(event.draws.results, { id: resultId });
                        if (resultIndex !== -1) {
                            event.draws.results.splice(resultIndex, 1);
                        }
                    }
                    if (event.results.length > 0) {
                        resultIndex = _.findIndex(event.results, { id: resultId });
                        if (resultIndex !== -1) {
                            event.results.splice(resultIndex, 1);
                        }
                    }
                });
            }
            return {
                ...state,
                results,
            };
        case 'CLUBS:META_FETCH_SUCCESS':
            return {
                ...state,
                metaData: action.data,
            };
        case 'CLUBS:FETCH_POWER6_STATS':
            return {
                ...state,
                power6StatsState: {
                    ...(state.power6StatsState),
                    loading: true,
                    completed: false,
                    successful: false,
                    errorMessage: null,
                },
                power6Stats: null,
            };
        case 'CLUBS:FETCH_POWER6_STATS_SUCCESS':
            return {
                ...state,
                power6StatsState: {
                    ...(state.power6StatsState),
                    loading: false,
                    completed: true,
                    successful: true,
                    errorMessage: null,
                },
                power6Stats: action.data.stats,
            };
        case 'CLUBS:FETCH_POWER6_STATS_FAILURE':
            return {
                ...state,
                power6StatsState: {
                    ...(state.power6StatsState),
                    loading: false,
                    completed: true,
                    successful: false,
                    errorMessage: 'could not fetch power6 stats',
                },
                power6Stats: null,
            };
        case CLUBS_UPDATE_MEMBER_SELECTION:
            const {
                selectedMembers = [],
                selectedMemberIds = [],
                selectAllMembers = false,
            } = action;
            return {
                ...state,
                clubMembersFetchState: {
                    ...state.clubMembersFetchState,
                    selectedMembers,
                    selectedMemberIds,
                    selectAllMembers,
                },
            };
        case CLUBS_UPDATE_FETCHSTATE:
            const updatedFetchState = updateFetchState(state, action);

            return {
                ...state,
                clubMembersFetchState: {
                    ...state.clubMembersFetchState,
                    ...updatedFetchState,
                    searchParams: {
                        ...state.clubMembersFetchState.searchParams,
                        excludeMemberIds: _.map(updatedFetchState.deletedMembers, 'memberId'),
                    },
                },
            };
        case CLUBS_GET_ORGANIZERS_SUCCESS:
            return {
                ...state,
                clubDetails: {
                    ...(state.clubDetails),
                    clubOrganizers: action.data,
                },
            };
        case CLUBS_FETCH_HIGHSCHOOL_STANDINGS_SEASONS:
            return {
                ...state,
                highSchoolStandingsSeasons: [],
            };
        case CLUBS_FETCH_HIGHSCHOOL_STANDINGS_SEASONS_SUCCESS:
            return {
                ...state,
                highSchoolStandingsSeasons: action.data.highSchoolStandingsSeasons,
            };
        case CLUBS_FETCH_HIGHSCHOOL_STANDINGS_SEASONS_FAILURE:
            return {
                ...state,
                highSchoolStandingsSeasons: [],
            };
        case CLUBS_FETCH_HIGHSCHOOL_STANDINGS:
            return {
                ...state,
                highSchoolStandingsState: {
                    ...(state.highSchoolStandingsState),
                    loading: true,
                    completed: false,
                    successful: false,
                    errorMessage: null,
                },
                highSchoolStandings: null,
            };
        case CLUBS_FETCH_HIGHSCHOOL_STANDINGS_SUCCESS:
            return {
                ...state,
                highSchoolStandingsState: {
                    ...(state.highSchoolStandingsState),
                    loading: false,
                    completed: true,
                    successful: true,
                    errorMessage: null,
                },
                highSchoolStandings: action.data.highSchoolStandings,
            };
        case CLUBS_FETCH_HIGHSCHOOL_STANDINGS_FAILURE:
            return {
                ...state,
                highSchoolStandingsState: {
                    ...(state.highSchoolStandingsState),
                    loading: false,
                    completed: true,
                    successful: false,
                    errorMessage: 'could not fetch power6 stats',
                },
                highSchoolStandings: null,
            };
        case EVENTS_INCLUDE_IN_CONFERENCE_SUCCESS: {
            const { teamMatches, teamMatchesUpcoming, teamMatchesRecent } = updateTeamMatchesIsConference(state, action.eventId, true);

            return {
                ...state,
                clubDetails: {
                    ...(state.clubDetails),
                    teamMatches,
                    teamMatchesUpcoming,
                    teamMatchesRecent,
                },
            };
        }
        case EVENTS_OMIT_FROM_CONFERENCE_SUCCESS: {
            const { teamMatches, teamMatchesUpcoming, teamMatchesRecent } = updateTeamMatchesIsConference(state, action.eventId, false);

            return {
                ...state,
                clubDetails: {
                    ...(state.clubDetails),
                    teamMatches,
                    teamMatchesUpcoming,
                    teamMatchesRecent,
                },
            };
        }
        case EVENTS_PUBLISH_SUCCESS: {
            const { teamMatches, teamMatchesUpcoming, teamMatchesRecent } = updateTeamMatchesPublished(state, action.eventId, true);

            return {
                ...state,
                clubDetails: {
                    ...(state.clubDetails),
                    teamMatches,
                    teamMatchesUpcoming,
                    teamMatchesRecent,
                },
            };
        }
        case EVENTS_UNPUBLISH_SUCCESS: {
            const { teamMatches, teamMatchesUpcoming, teamMatchesRecent } = updateTeamMatchesPublished(state, action.eventId, false);

            return {
                ...state,
                clubDetails: {
                    ...(state.clubDetails),
                    teamMatches,
                    teamMatchesUpcoming,
                    teamMatchesRecent,
                },
            };
        }
        case EVENTS_DELETE_SUCCESS: {
            const { teamMatches, teamMatchesUpcoming, teamMatchesRecent } = deleteTeamMatch(state, action.eventId);

            return {
                ...state,
                clubDetails: {
                    ...(state.clubDetails),
                    teamMatches,
                    teamMatchesUpcoming,
                    teamMatchesRecent,
                },
            };
        }
        case EVENTS_SAVE_SUCCESS:
        case EVENTS_UPDATE_SUCCESS: {
            const { tmsEventsRecent, tmsEventsUpcoming, draftEvents, eventsFetched, draftEventsFetched } = updateClubEvent(state, action.res.data);

            return {
                ...state,
                clubDetails: {
                    ...(state.clubDetails),
                    tmsEventsRecent,
                    tmsEventsUpcoming,
                    draftEvents,
                },
                tmsEventsFetchState: {
                    ...(state.tmsEventsFetchState),
                    eventsFetched,
                    draftEventsFetched,
                },
            };
        }

        case 'CLUBS_FETCH_ADULT_TEAMTENNIS_EVENTS': {
            return {
                ...state,
                adultTeamTennisEventsState: {
                    ...state.adultTeamTennisEventsState,
                    loading: true,
                },
                adultTeamTennisEvents: {
                    upcomingEvents: [],
                    pastEvents: [],
                },
            };
        }

        case 'CLUBS_FETCH_ADULT_TEAMTENNIS_EVENTS_SUCCESS': {
            const structuredTeamEvents = action.data;
            structuredTeamEvents.forEach(event => {
                event.momentStartDate = moment(event.startDate);
                event.momentEndDate = moment(event.endDate);
            });
            return {
                ...state,
                adultTeamTennisEventsState: {
                    ...state.adultTeamTennisEventsState,
                    loading: false,
                    completed: true,
                    successful: true,
                    errorMessage: null,
                },
                adultTeamTennisEvents: {
                    pastEvents: structuredTeamEvents.filter(event => event.momentEndDate < now).sort(comparator(comparatorParams)),
                    upcomingEvents: structuredTeamEvents.filter(event => event.momentEndDate >= now).sort(comparator(upcomingComparatorParams)),
                },
            };
        }

        case 'CLUBS_INCLUDE_IN_ATT_STANDINGS_SUCCESS':
        case 'CLUBS_OMIT_FROM_ATT_STANDINGS_SUCCESS': {
            return {
                ...state,
                adultTeamTennisEvents: {
                    ...state.adultTeamTennisEvents,
                    pastEvents: state.adultTeamTennisEvents.pastEvents.map(event => {
                        if (event.id === action.eventId) {
                            return {
                                ...event,
                                isConference: !event.isConference,
                            };
                        }
                        return {
                            ...event,
                        };
                    }),
                    upcomingEvents: state.adultTeamTennisEvents.upcomingEvents.map(event => {
                        if (event.id === action.eventId) {
                            return {
                                ...event,
                                isConference: !event.isConference,
                            };
                        }
                        return {
                            ...event,
                        };
                    }),
                },
            };
        }

        case 'CLUBS_FETCH_ADULT_TEAMTENNIS_EVENTS_FAILURE': {
            return {
                ...state,
                adultTeamTennisEventsState: {
                    loading: false,
                    completed: true,
                    successful: false,
                    errorMessage: action.data,
                },
                adultTeamTennisEvents: {
                    upcomingEvents: [],
                    pastEvents: [],
                    unpublishedEvents: [],
                },
            };
        }

        case 'CLUBS_FETCH_ADULT_TEAMTENNIS_ROSTER': {
            return {
                ...state,
                adultTeamTennisRosterState: {
                    ...state.adultTeamTennisRosterState,
                    loading: true,
                },
                adultTeamTennisRoster: [],
            };
        }
        case 'CLUBS_FETCH_ADULT_TEAMTENNIS_ROSTER_SUCCESS': {
            return {
                ...state,
                adultTeamTennisRosterState: {
                    ...state.adultTeamTennisRosterState,
                    loading: false,
                    completed: true,
                    successful: true,
                    errorMessage: null,
                },
                adultTeamTennisRoster: action.data.roster,
            };
        }
        case 'CLUBS_FETCH_ADULT_TEAMTENNIS_ROSTER_FAILURE': {
            return {
                ...state,
                adultTeamTennisRosterState: {
                    ...state.adultTeamTennisRosterState,
                    loading: false,
                    completed: true,
                    successful: false,
                    errorMessage: action.data,
                },
                adultTeamTennisRoster: [],
            };
        }

        case 'CLUBS_FETCH_ADULT_TEAMTENNIS_STANDINGS': {
            return {
                ...state,
                adultTeamTennisStandingsState: {
                    ...state.adultTeamTennisStandingsState,
                    loading: true,
                },
                adultTeamTennisStandings: [],
            };
        }

        case 'CLUBS_FETCH_ADULT_TEAMTENNIS_STANDINGS_SUCCESS': {
            return {
                ...state,
                adultTeamTennisStandingsState: {
                    ...state.adultTeamTennisStandingsState,
                    loading: false,
                    completed: true,
                    successful: true,
                    errorMessage: null,
                },
                adultTeamTennisStandings: action.data.adultTeamTennisStandings.teams,
            };
        }

        case 'CLUBS_FETCH_ADULT_TEAMTENNIS_STANDINGS_FAILURE': {
            return {
                ...state,
                adultTeamTennisStandingsState: {
                    ...state.adultTeamTennisStandingsState,
                    loading: false,
                    completed: true,
                    successful: false,
                    errorMessage: action.data,
                },
                adultTeamTennisStandings: [],
            };
        }

        case 'CLUBS_FETCH_CLUB_TEAM_RATINGS': {
            return {
                ...state,
                clubTeamRatingState: {
                    ...state.clubTeamRatingState,
                    loading: true,
                },
                clubTeamRatings: null,
            };
        }

        case 'CLUBS_FETCH_CLUB_TEAM_RATINGS_SUCCESS': {
            return {
                ...state,
                clubTeamRatingState: {
                    ...state.clubTeamRatingState,
                    loading: false,
                    completed: true,
                    successful: true,
                    errorMessage: null,
                },
                clubTeamRatings: action.data,
            };
        }

        case 'CLUBS_FETCH_CLUB_TEAM_RATINGS_FAILURE': {
            return {
                ...state,
                clubTeamRatingState: {
                    ...state.clubTeamRatingState,
                    loading: false,
                    completed: true,
                    successful: false,
                    errorMessage: action.data,
                },
                clubTeamRatings: null,
            };
        }
        default:
            return state;
    }
}

export default app;
